import { Avatar, Box, Divider, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { logout } from 'redux/reducer/authSlice';
import Routes from 'utils/Route';

import useStyles from '../styles';

const MenuProfile = () => {
  const classes = useStyles();
  const { t } = useTranslation();
  const user = useSelector((state) => state.auth.account.user);
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleLogOut = () => {
    dispatch(logout());
    navigate(Routes.Login);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <Box>
        <Tooltip title={t('account_setting')}>
          <IconButton
            onClick={handleClick}
            size="small"
            sx={{ ml: 2 }}
          >
            <Avatar
              className={classes.avatarProfile}
              src={user?.avatar}
            />
          </IconButton>
        </Tooltip>
      </Box>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        classes={{
          paper: classes.menuPaper,
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
      >
        <div className={classes.wrapItemMenuProfile}>
          <div className={classes.textAlignItemProfile}>
            <Avatar
              className={classes.avatarItemMenuProfile}
              src={user?.avatar}
            />
            <div className={classes.textUserName}>{user?.name}</div>
            <div className={classes.textEmail}>{user?.email}</div>
          </div>
        </div>

        <Divider />

        <Divider />
        <MenuItem
          onClick={handleLogOut}
          className={classes.menuItem}
        >
          {t('sign_out')}
        </MenuItem>
      </Menu>
    </div>
  );
};
export default MenuProfile;
